<script lang="ts">
  import Checkbox from "./Checkbox.svelte";
  import Beta from "./Beta.svelte";
  import CloseIcon from "./CloseIcon.svelte";
  import ClickOutsideNode from "../helpers/useClickOutsideNode";

  export let options;
  export let tags;
  export let templateCount = 0;
  let isSearchMenuOption = false;

  const toggleSearchMenu = () => {
    isSearchMenuOption = !isSearchMenuOption;
  };

  const handleClickTag = (thisTag) => {
    const newTags = tags.filter((tag) => tag !== thisTag);
    tags = newTags;
  };

  const handleClickOutside = () => {
    toggleSearchMenu();
  };
</script>

<div class="container">
  <div class="filter-container">
    <div class="filter-button" on:click={toggleSearchMenu}>
      Filter templates ({templateCount})
      <span class="filter-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <title>sort-tool</title>
          <g fill="currentColor">
            <path
              d="M11,1H1A1,1,0,0,0,1,3H11a1,1,0,0,0,0-2Z"
              fill="currentColor"
            />{" "}
            <path
              d="M9,5H3A1,1,0,0,0,3,7H9A1,1,0,0,0,9,5Z"
              data-color="color-2"
            />{" "}
            <path
              d="M7,9H5a1,1,0,0,0,0,2H7A1,1,0,0,0,7,9Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </span>
    </div>

    {#if isSearchMenuOption === true}
      <div
        class="filter-menu"
        use:ClickOutsideNode
        on:click_outside={handleClickOutside}
      >
        <div class="filter-menu-inner">
          <div class="close-button" on:click={toggleSearchMenu}>
            <CloseIcon />
          </div>

          {#each Object.keys(options) as key}
            <div class="column" id={key}>
              <div class="column-title">{key}</div>
              <div class="options">
                {#each options[key] as option}
                  <div class="checkbox-container">
                    <Checkbox bind:tags value={option} checked={false} />
                    {#if option === "darkMode"}
                      <Beta />
                    {/if}
                  </div>
                {/each}
              </div>
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </div>
  {#each tags as tag}
    <div class="tag" on:click={() => handleClickTag(tag)}>
      {tag}
      <span class="close-icon">
        <CloseIcon />
      </span>
    </div>
  {/each}
</div>

<style>
  .container {
    position: fixed;
    top: 150px;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    padding: 14px 28px;
    background-color: #0f1010;
    width: 100%;
    min-height: 75px;
  }

  .filter-container {
    position: relative;
  }

  .filter-button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #75fff1;
    padding: 8px 8px;
    height: calc(100% - 30px);
    color: black;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
  }

  .filter-icon {
    margin-left: 4px;
  }

  .filter-menu {
    position: absolute;
    top: 54px;
    left: -1px;
  }

  .filter-menu-inner {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 32px;
    position: relative;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    padding: 20px;
    border-radius: 8px;
    background-color: rgb(66 69 81);
  }

  .column {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
  }

  .column::after {
    position: absolute;
    top: 0;
    right: -16px;
    background: #636060;
    width: 1px;
    height: 100%;
    content: " ";
  }

  .column:last-child:after {
    display: none;
  }

  .column-title {
    margin-bottom: 12px;
    color: #bdbfc8;
    font-weight: 600;
    text-transform: capitalize;
  }

  .options {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 6px;
  }

  .checkbox-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }

  .tag {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: rgb(66 69 81);
    padding: 8px 8px 8px 10px;
    height: calc(100% - 30px);
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
  }

  .close-icon {
    display: inline-flex;
    margin-left: 4px;
  }

  .close-button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -8px;
    right: -8px;
    padding: 8px;
    padding-left: 10px;
    border-radius: 50%;
    background-color: rgb(84 87 101);
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
</style>
